import { HttpInterceptorFn, HttpContextToken } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const BYPASS_AUTH = new HttpContextToken<boolean>(() => false);

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    const token = authService.getToken();

    // Do not attach Authorization token to public auth endpoints or assets
    const isPublicUrl =
        req.url.includes('/auth/') ||
        req.url.includes('/assets/') ||
        req.context.get(BYPASS_AUTH);

    if (token && !isPublicUrl) {
        const authReq = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${token}`)
        });
        return next(authReq);
    }

    return next(req);
};

